import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField } from '@mui/material';

export default function PostDetailModal({
  open,
  onClose,
  onConfirm,
  type,
  setOTP,
  OTP,
  post,
  confirmDisabled = false,
  onResendCode,
  loading = false,
  hepsijetDeliverName,
  setHepsijetDeliverName,
  hepsijetDeliverLastname,
  setHepsijetDeliverLastname,
  hepsijetDeliverTC,
  setHepsijetDeliverTC,
}) {
  const renderDialogContent = () => {
    switch (type) {
      case 'deliver':
        if (post?.apiUserType === 'hepsijet') {
          return (
            <>
              <p>Teslim etmek için alanları doldurunuz.</p>
              <TextField
                label="Adınız"
                variant="outlined"
                fullWidth
                value={hepsijetDeliverName}
                onChange={(e) => setHepsijetDeliverName?.(e.target.value)}
                sx={{ mb: 2 }}
              />
              <TextField
                label="Soyadınız"
                variant="outlined"
                fullWidth
                value={hepsijetDeliverLastname}
                onChange={(e) => setHepsijetDeliverLastname?.(e.target.value)}
                sx={{ mb: 2 }}
              />
              <TextField
                label="TC No"
                variant="outlined"
                fullWidth
                value={hepsijetDeliverTC}
                onChange={(e) =>
                  setHepsijetDeliverTC?.(e.target.value.replace(/[^\d]/g, '').slice(0, 11))
                }
              />
            </>
          );
        }
        return (
          <>
            <p>Teslim etmek için OTP kodunu giriniz.</p>
            <TextField
              label="OTP Kodu"
              variant="outlined"
              fullWidth
              value={OTP}
              onChange={(e) => setOTP(e.target.value)}
            />
            {onResendCode ? (
              <Button variant="text" onClick={onResendCode} sx={{ mt: 1, px: 0 }}>
                Tekrar Kod Gönder
              </Button>
            ) : null}
          </>
        );
      case 'take':
        return <p>{post?.barcode ? `${post.barcode} numaralı gönderiyi teslim almak istediğinize emin misiniz?` : 'Teslim almak istediğinize emin misiniz?'}</p>;
      case 'return':
        return <p>İade etmek istediğinize emin misiniz?</p>;
      case 'setInBranch':
        return <p>Zimmete almak istediğinize emin misiniz?</p>;
      default:
        return null;
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>İşlem Onayı</DialogTitle>
      <DialogContent>
        {renderDialogContent()}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={loading}>
          Kapat
        </Button>
        <Button onClick={onConfirm} color="primary" disabled={confirmDisabled || loading}>
          Onayla
        </Button>
      </DialogActions>
    </Dialog>
  );
}
